import { render, staticRenderFns } from "./AcceptedAppointmentModalItem.vue?vue&type=template&id=0f63708a&scoped=true"
import script from "./AcceptedAppointmentModalItem.vue?vue&type=script&lang=js"
export * from "./AcceptedAppointmentModalItem.vue?vue&type=script&lang=js"
import style0 from "./AcceptedAppointmentModalItem.vue?vue&type=style&index=0&id=0f63708a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63708a",
  null
  
)

export default component.exports